import React, { useState } from 'react';

export default function DashboardModals({ openModalId, onCloseModal, onShowToast, onSubmitNewTask, toastMsg }) {
  const [taskInput, setTaskInput] = useState('');

  const handleSubmit = () => {
    if (!taskInput.trim()) {
      onShowToast('Vui lòng nhập mục tiêu công việc!');
      return;
    }
    onSubmitNewTask(taskInput);
    setTaskInput('');
    onCloseModal();
  };

  return (
    <>
      {/* MODAL 1: Phê Duyệt 1-Click Của Ban Lãnh Đạo */}
      <div className={`modal-overlay ${openModalId === 'modal-decisions' ? 'active' : ''}`} id="modal-decisions">
        <div className="modal-card">
          <div className="modal-card-header">
            <div className="modal-card-title">
              <i className="fa-solid fa-signature"></i> TRUNG TÂM PHÊ DUYỆT BAN LÃNH ĐẠO (ANH THẾ &amp; CHỊ THẢO)
            </div>
            <button className="btn-modal-close" onClick={() => onCloseModal()} type="button">
              <i className="fa-solid fa-xmark"></i>
            </button>
          </div>
          <div className="modal-card-body">
            <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
              <div style={{ background: '#181e2b', border: '1px solid var(--border-subtle)', borderRadius: 'var(--radius-md)', padding: '14px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px' }}>
                  <strong style={{ color: 'white', fontSize: '13px' }}>1. Phê duyệt ngân sách Video Marketing PRJ-TTP: 5.000.000 đ</strong>
                  <span style={{ color: 'var(--gold)', fontWeight: '700', fontSize: '11px' }}>Ưu tiên P1</span>
                </div>
                <p style={{ color: 'var(--text-muted)', fontSize: '11.5px', marginBottom: '10px' }}>
                  Sản xuất Batch 10 video ngắn Reels/TikTok giới thiệu danh mục thuốc bán chạy trên chothuoc247.vn. Dự kiến tiếp cận 25.000 lượt xem nhà thuốc.
                </p>
                <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                  <button className="btn-quick" style={{ width: 'auto' }} onClick={() => onShowToast('Đã gửi yêu cầu chỉnh sửa kịch bản!')} type="button">
                    Yêu cầu sửa
                  </button>
                  <button className="btn-quick primary" style={{ width: 'auto' }} onClick={() => onShowToast('ĐÃ PHÊ DUYỆT NGÂN SÁCH VIDEO MKT!')} type="button">
                    Phê duyệt ngay
                  </button>
                </div>
              </div>

              <div style={{ background: '#181e2b', border: '1px solid var(--border-subtle)', borderRadius: 'var(--radius-md)', padding: '14px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px' }}>
                  <strong style={{ color: 'white', fontSize: '13px' }}>2. Duyệt bảng tính hoa hồng kinh doanh Kỳ 1 Tháng 8: 48.500.000 đ</strong>
                  <span style={{ color: '#60a5fa', fontWeight: '700', fontSize: '11px' }}>Ưu tiên P1</span>
                </div>
                <p style={{ color: 'var(--text-muted)', fontSize: '11.5px', marginBottom: '10px' }}>
                  Kế toán Agent đã tự động đối soát 100% doanh thu theo Nhóm hàng 1, 2, 3 từ CSDL chothuoc247.vn cho 14 nhân sự kinh doanh.
                </p>
                <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                  <button className="btn-quick" style={{ width: 'auto' }} onClick={() => onShowToast('Đang mở bảng đối soát chi tiết...')} type="button">
                    Xem đối soát
                  </button>
                  <button className="btn-quick primary" style={{ width: 'auto' }} onClick={() => onShowToast('ĐÃ PHÊ DUYỆT BẢNG HOA HỒNG KỲ 1!')} type="button">
                    Đồng ý chi hoa hồng
                  </button>
                </div>
              </div>

              <div style={{ background: '#181e2b', border: '1px solid var(--border-subtle)', borderRadius: 'var(--radius-md)', padding: '14px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px' }}>
                  <strong style={{ color: 'white', fontSize: '13px' }}>3. Duyệt PO Đặt Hàng Thu Mua 5.000 Hộp Kháng Viêm Alpha: 125.000.000 đ</strong>
                  <span style={{ color: '#34d399', fontWeight: '700', fontSize: '11px' }}>Tiết kiệm 6.7%</span>
                </div>
                <p style={{ color: 'var(--text-muted)', fontSize: '11.5px', marginBottom: '10px' }}>
                  Đã split đơn cho NCC1 (Đủ hàng) và NCC2 (Flash deal), tiết kiệm 8.400.000 đ và bảo vệ 100% dòng tiền ngoài hóa đơn VAT.
                </p>
                <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                  <button className="btn-quick primary" style={{ width: 'auto' }} onClick={() => onShowToast('ĐÃ NGHIỆM THU ĐƠN PO THU MUA!')} type="button">
                    Nghiệm thu PO
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-card-footer">
            <button className="btn-quick" style={{ width: 'auto' }} onClick={() => onCloseModal()} type="button">
              Đóng
            </button>
          </div>
        </div>
      </div>

      {/* MODAL 2: Giao Task Cho AI */}
      <div className={`modal-overlay ${openModalId === 'modal-task' ? 'active' : ''}`} id="modal-task">
        <div className="modal-card" style={{ maxWidth: '550px' }}>
          <div className="modal-card-header">
            <div className="modal-card-title">
              <i className="fa-solid fa-plus"></i> GIAO TASK CHO AI AGENT TECHMEDCOM
            </div>
            <button className="btn-modal-close" onClick={() => onCloseModal()} type="button">
              <i className="fa-solid fa-xmark"></i>
            </button>
          </div>
          <div className="modal-card-body">
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <div>
                <label style={{ fontSize: '11px', color: 'var(--text-muted)', fontWeight: '700', textTransform: 'uppercase' }}>
                  Mục tiêu công việc (Task Objective):
                </label>
                <input
                  type="text"
                  value={taskInput}
                  onChange={(e) => setTaskInput(e.target.value)}
                  placeholder="VD: Khảo sát danh mục thuốc kháng viêm bán chạy trên chothuoc247.vn"
                  style={{ width: '100%', background: '#0e1117', border: '1px solid var(--border-subtle)', borderRadius: 'var(--radius-sm)', padding: '8px 12px', color: 'white', marginTop: '4px', outline: 'none' }}
                />
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
                <div>
                  <label style={{ fontSize: '11px', color: 'var(--text-muted)', fontWeight: '700', textTransform: 'uppercase' }}>Dự Án Trực Thuộc:</label>
                  <select style={{ width: '100%', background: '#0e1117', border: '1px solid var(--border-subtle)', borderRadius: 'var(--radius-sm)', padding: '8px 12px', color: 'white', marginTop: '4px', outline: 'none' }}>
                    <option>PRJ-TTP: Thế Thảo Pharma</option>
                    <option>PRJ-TOP: TopPharma</option>
                    <option>PRJ-TTCE: Tủ thuốc cho em</option>
                    <option>PRJ-TECHPHA: Techpha</option>
                  </select>
                </div>
                <div>
                  <label style={{ fontSize: '11px', color: 'var(--text-muted)', fontWeight: '700', textTransform: 'uppercase' }}>Phòng Ban / Agent:</label>
                  <select style={{ width: '100%', background: '#0e1117', border: '1px solid var(--border-subtle)', borderRadius: 'var(--radius-sm)', padding: '8px 12px', color: 'white', marginTop: '4px', outline: 'none' }}>
                    <option>Marketing Agent</option>
                    <option>Thu Mua Agent</option>
                    <option>Kho Vận Agent</option>
                    <option>Kế Toán Agent</option>
                    <option>HCNS Agent</option>
                    <option>Sales Agent</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-card-footer">
            <button className="btn-quick" style={{ width: 'auto' }} onClick={() => onCloseModal()} type="button">
              Hủy
            </button>
            <button className="btn-quick primary" style={{ width: 'auto' }} onClick={handleSubmit} type="button">
              Kích hoạt Agent
            </button>
          </div>
        </div>
      </div>

      {/* MODAL 3: OpenClaw Brain */}
      <div className={`modal-overlay ${openModalId === 'modal-brain' ? 'active' : ''}`} id="modal-brain">
        <div className="modal-card">
          <div className="modal-card-header">
            <div className="modal-card-title">
              <i className="fa-solid fa-brain"></i> OPENCLAW BRAIN — KHO TRI THỨC VẬN HÀNH TECHMEDCOM
            </div>
            <button className="btn-modal-close" onClick={() => onCloseModal()} type="button">
              <i className="fa-solid fa-xmark"></i>
            </button>
          </div>
          <div className="modal-card-body">
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <div style={{ background: '#181e2b', padding: '12px', borderRadius: 'var(--radius-sm)' }}>
                <strong style={{ color: 'var(--gold)' }}>
                  <i className="fa-solid fa-microchip"></i> Thư Viện Kỹ Năng (AI Skills) Vận Hành:
                </strong>
                <ul style={{ margin: '6px 0 0 16px', color: '#cbd5e1', fontSize: '11.5px', lineHeight: '1.6' }}>
                  <li><code>skill-video-batch-gen</code>: Tự động sản xuất kịch bản &amp; render video ngắn TikTok/Reels Dược.</li>
                  <li><code>skill-po-split-ncc</code>: Tối ưu phân bổ PO giữa 2 NCC và tách dòng tiền ngoài hóa đơn VAT.</li>
                  <li><code>skill-cccd-ocr-vision</code>: OCR 2 mặt CCCD và đối chiếu hồ sơ nhân sự tự động.</li>
                  <li><code>skill-batch-shipping-label</code>: Tạo 1 file PDF in nhiệt gộp 50-100 đơn CPN giao nhà thuốc.</li>
                  <li><code>skill-commission-calc</code>: Tính hoa hồng nhóm hàng 1, 2, 3 trực tiếp từ CSDL chothuoc247.vn.</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="modal-card-footer">
            <button className="btn-quick" style={{ width: 'auto' }} onClick={() => onCloseModal()} type="button">
              Đóng
            </button>
          </div>
        </div>
      </div>

      {/* Toast Notification Box */}
      {toastMsg && (
        <div className="toast-box" style={{ display: 'flex' }}>
          <i className="fa-solid fa-circle-check" style={{ color: 'var(--gold)' }}></i>
          <span>{toastMsg}</span>
        </div>
      )}
    </>
  );
}
